<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :detail-response-path="detailResponsePath"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getCertificate } from '@/services/certificates/getCertificate'
import { getHistoricalByCertificate } from '@/services/historical/getHistoricalByCertificate'
import { getHistoricalByCertificateExcel } from '@/services/historical/getHistoricalByCertificateExcel'

export default {
  name: 'list-certificate-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 20,
      vuexnamespace: 'historicalCert',
      headerUrl: 'certificates/detail',
      detailResponsePath: 'Certificado',
      breadcrumbs: [
        { url: 'certificates', name: i18n.t('certificates.header') },
        { paths: ['CommonName'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('certificates.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return {
        serialNumber: this.$route.params.serial,
        idEmpresa: this.$route.params.idCliente,
        tipoCertificado: this.$route.params.tipoCertificado,
      }
    },
    getParamsDetalleAux: function (data) {
      return this.$route.params
    },
    getDetalleAux: async function (params) {
      return await getCertificate(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByCertificateExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByCertificate(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
